'use client'
import { CaptionProps, useNavigation } from 'react-day-picker'
import cn from 'classnames'
import { format } from 'date-fns'
import { dayPickerFormats, testIds } from '@/root/shared-consts'
import { ChevronDownIcon } from '@/root/ui/shared/icons/ChevronDownIcon'
import { useCustomRouter } from '@/root/shared-hooks'
import { enUS, es, ar, et } from 'date-fns/locale'

interface CustomNavbarProps extends CaptionProps {
  captionClassName?: string
}

export const CustomNavbar = ({ captionClassName, ...props }: CustomNavbarProps) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation()
  const { locale } = useCustomRouter()

  const dateFnsLocale = getDateFnsLocale(locale)

  return (
    <div className={cn('flex w-full justify-between px-3', captionClassName ?? 'text-base')}>
      <h2>{format(props.displayMonth, dayPickerFormats.general, { locale: dateFnsLocale }).toUpperCase()}</h2>
      <span className="flex gap-5">
        <button
          data-testid={testIds.search.calendarBack}
          disabled={!previousMonth}
          onClick={() => previousMonth && goToMonth(previousMonth)}
        >
          <ChevronDownIcon width={14} height={14} color="primary-base" className="rotate-90 rtl:-rotate-90" />
        </button>
        <button
          data-testid={testIds.search.calendarForward}
          disabled={!nextMonth}
          onClick={() => nextMonth && goToMonth(nextMonth)}
        >
          <ChevronDownIcon width={14} height={14} color="primary-base" className="-rotate-90 rtl:rotate-90" />
        </button>
      </span>
    </div>
  )
}

export const getDateFnsLocale = (locale: string) => {
  switch (locale) {
    case 'es':
      return es
    case 'et':
      return et
    case 'ar':
      return ar
    default:
      return enUS
  }
}
